import React from 'react'

import { Icon, Tooltip } from '@fourthwall/components'
import { ExclamationMarkIcon } from '@fourthwall/icons'

import * as S from './ErrorBadge.styled'

export const ErrorBadge = () => (
  <Tooltip
    reference={
      <S.Container>
        <div>Error</div>
        <div>
          <Icon component={ExclamationMarkIcon} height={16} />
        </div>
      </S.Container>
    }
  >
    Please contact our support or your partner manager.
  </Tooltip>
)
